export const specialOffers = [
  {
    id: 'ceramic',
    serviceName: '$999 Ceramic coating special',
    eyebrow: 'Paint Correction + Ceramic',
    title: '5-Year Ceramic Coating',
    price: '$999',
    priceNote: 'starting at',
    wasPrice: null,
    tagline: 'Mirror-like, wet-look shine locked in for 5 years.',
    image: '/images/ceramic-after.jpg',
    includes: [
      '1-step paint correction removes 70–95% of scratches & swirl marks',
      'Removes light oxidation and brings back deep, true color',
      'Mirror-like gloss with that wet look',
      'Professional ceramic coating locks it all in for 5 years',
      'Hydrophobic finish: water and dirt slide right off',
      'UV protection against New Mexico sun',
    ],
  },
  {
    id: 'full-detail',
    serviceName: 'Full Detail',
    promo: true,
    eyebrow: 'Interior + Exterior',
    title: 'Full Detail',
    price: '$249',
    priceNote: 'starting at',
    wasPrice: '$275',
    tagline: '$25 off our regular price, for Facebook neighbors only.',
    image: '/images/special-full-detail.jpg',
    includes: [
      'Deep cleaning of all hard plastics, dash, doors & console',
      'Cracks, crevices, vents & seams detailed by hand',
      'Windows cleaned streak-free inside & out',
      'Leather seats deep cleaned & conditioned',
      'Light shampooing of carpets & mats included',
      'Thorough vacuum, plus exterior hand wash, wheels & tires',
    ],
  },
];

export const howItWorks = [
  { step: '1', title: 'Pick your package', text: 'Choose a time that works for you, online in under 2 minutes.' },
  { step: '2', title: 'Hold it with $50', text: 'A small deposit holds your spot, and it goes toward your total.' },
  { step: '3', title: 'We come to you', text: 'Home or work, anywhere in Albuquerque, Rio Rancho or Los Lunas.' },
];

// Used if the promo lookup fails; the server still validates the discount.
export const FALLBACK_PROMO = { code: 'facebook', label: 'Facebook special', services: { 'full detail': 2500 } };
